import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const PHONE = '07760 881212';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const navLinks = [
    { label: 'Home', to: '/' },
    { label: 'Services', to: '/services' },
    { label: 'Locations', to: '/locations' },
    { label: 'About', to: '/about' },
    { label: 'Blog', to: '/blog' },
  ];

  const isActive = (to: string) => location.pathname === to;

  return (
    <>
      {/* Top bar — cream/gold */}
      <div className="bg-gold-400 text-navy-800 text-sm font-bold py-2 px-4 text-center flex items-center justify-center gap-3">
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-flashlight-fill text-base"></i>
        </span>
        <span>Dukeries Electrical — Local Electrician Worksop — Call Now:</span>
        <a
          href={`tel:${PHONE.replace(/\s/g, '')}`}
          className="underline font-extrabold hover:opacity-80 cursor-pointer whitespace-nowrap"
        >
          {PHONE}
        </a>
      </div>

      {/* Main Navbar — deep navy */}
      <nav className="sticky top-0 z-50 bg-navy-800 border-b-2 border-gold-400">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-18 py-3">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer shrink-0">
            <div className="w-9 h-9 flex items-center justify-center bg-gold-400 rounded-md">
              <i className="ri-flashlight-fill text-navy-800 text-xl"></i>
            </div>
            <div className="flex flex-col leading-none">
              <span className="font-heading font-extrabold text-gold-400 text-lg tracking-tight leading-none">DUKERIES</span>
              <span className="font-heading font-bold text-white text-xs tracking-widest leading-none mt-0.5">ELECTRICAL</span>
            </div>
          </Link>

          {/* Desktop Nav Links */}
          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`font-bold text-base uppercase tracking-widest transition-colors cursor-pointer whitespace-nowrap pb-1 ${
                  isActive(link.to)
                    ? 'text-gold-400 border-b-2 border-gold-400'
                    : 'text-gold-200 hover:text-gold-400 hover:border-b-2 hover:border-gold-400'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA Phone Button */}
          <a
            href={`tel:${PHONE.replace(/\s/g, '')}`}
            className="hidden md:flex items-center gap-2 bg-gold-400 hover:bg-gold-300 text-navy-800 font-extrabold text-base px-6 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-base"></i>
            </span>
            {PHONE}
          </a>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden text-gold-400 cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span className="w-7 h-7 flex items-center justify-center">
              <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-3xl`}></i>
            </span>
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="md:hidden bg-navy-800 border-t border-gold-400/40 px-6 py-5 flex flex-col gap-5">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`font-bold text-lg uppercase tracking-widest cursor-pointer ${
                  isActive(link.to) ? 'text-gold-400' : 'text-gold-200 hover:text-gold-400'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href={`tel:${PHONE.replace(/\s/g, '')}`}
              className="flex items-center justify-center gap-2 bg-gold-400 text-navy-800 font-extrabold text-base px-5 py-3 rounded-md cursor-pointer whitespace-nowrap mt-2"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-base"></i>
              </span>
              Call {PHONE}
            </a>
          </div>
        )}
      </nav>
    </>
  );
}
